import React, { useState, useEffect } from 'react';
import { PublicLayout } from '../../components/layout/PublicLayout';
import { newsAPI } from '../../lib/api';
import { CalendarBlank, Scroll } from '@phosphor-icons/react';

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await newsAPI.getPublic();
        setNews(response.data);
      } catch (error) {
        console.log('Error fetching news');
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  const filteredNews = filter === 'all' ? news : news.filter(n => n.news_type === filter);

  return (
    <PublicLayout>
      {/* Header */}
      <section className="py-20 bg-[#1A1614] text-center" data-testid="news-header">
        <p className="text-overline mb-4">Official Communications</p>
        <h1 className="font-heading text-4xl sm:text-5xl text-white mb-4">
          News & Decrees
        </h1>
        <p className="text-[#8A847A] max-w-2xl mx-auto px-4">
          Official announcements, decrees, and news from the Grand Priory
        </p>
      </section>

      {/* Filter */}
      <section className="py-8 bg-[#F5F2EB] border-b border-[#D8D2C4]">
        <div className="max-w-4xl mx-auto px-4 flex gap-4 justify-center">
          {['all', 'news', 'decree', 'announcement'].map(type => (
            <button
              key={type}
              onClick={() => setFilter(type)}
              className={`px-4 py-2 text-sm font-medium capitalize transition-colors ${
                filter === type 
                  ? 'bg-[#7B1818] text-white' 
                  : 'text-[#4A453E] hover:text-[#7B1818]'
              }`}
              data-testid={`filter-${type}`}
            >
              {type === 'all' ? 'All' : type}
            </button>
          ))}
        </div>
      </section>

      {/* News List */}
      <section className="py-16 bg-white" data-testid="news-list">
        <div className="max-w-4xl mx-auto px-4">
          {loading ? (
            <div className="flex justify-center py-12">
              <div className="spinner" />
            </div>
          ) : filteredNews.length > 0 ? (
            <div className="space-y-8">
              {filteredNews.map(item => (
                <article 
                  key={item.id}
                  className="border-l-2 border-[#C5A059] pl-6 py-2"
                  data-testid={`news-item-${item.id}`}
                >
                  <div className="flex items-center gap-4 mb-2">
                    <span className="text-overline text-xs">
                      {item.news_type?.toUpperCase() || 'NEWS'}
                    </span>
                    <span className="flex items-center gap-1 text-sm text-[#8A847A]">
                      <CalendarBlank size={14} />
                      {new Date(item.created_at).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                      })}
                    </span>
                  </div>
                  <h2 className="font-heading text-2xl text-[#1A1614] mb-2">{item.title}</h2>
                  <p className="text-[#4A453E] leading-relaxed">{item.content}</p>
                </article>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <Scroll size={48} className="mx-auto text-[#8A847A] mb-4" />
              <p className="text-[#8A847A]">No news or decrees have been published yet.</p>
            </div>
          )}
        </div>
      </section>
    </PublicLayout>
  );
};

export default NewsPage;
